/**
 * Banner 1058 — KUK home "Want to set yourself apart" band.
 * A photograph under a scrim with an icon, one line of copy and an outline CTA.
 * No metadata rows.
 */

export const BANNER_1058_CONSTANTS = {
  BANNER_FIELDS_CONFIG: [
    {
      fieldName: "background_image",
      label: "Background photo (desktop)",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload background photo",
      defaultValue: "",
    },
    {
      fieldName: "background_image_mobile",
      label: "Background photo (mobile)",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Optional — uses the desktop photo if empty",
      defaultValue: "",
    },
    {
      fieldName: "bleed_background_color",
      label: "Scrim over the photo",
      value: "rgba(0, 0, 0, 0.5)",
      valueType: "string",
      filedType: "RGBA",
      placeholder: "rgba(0, 0, 0, 0.5)",
      description: "The reference is black at 50%, so white copy stays legible.",
      defaultValue: "rgba(0, 0, 0, 0.5)",
    },
    {
      fieldName: "hero_section_height",
      label: "Band height (px)",
      value: 285,
      valueType: "number",
      filedType: "INPUT",
      placeholder: "285",
      defaultValue: 285,
    },
    {
      fieldName: "icon",
      label: "Icon",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Icon name (e.g. note) or an image URL",
      defaultValue: "",
    },
    {
      fieldName: "alt_icon",
      label: "Icon alt text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      defaultValue: "",
    },
    {
      fieldName: "icon_color",
      label: "Icon colour",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "title",
      label: "Heading",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Want to set yourself apart in the workforce?",
      defaultValue: "",
    },
    {
      fieldName: "title_color",
      label: "Heading colour",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "apply_now_show",
      label: "Show CTA button",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      defaultValue: true,
    },
    {
      fieldName: "apply_now_text",
      label: "CTA label",
      value: "Get in touch",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Get in touch",
      defaultValue: "Get in touch",
    },
    {
      fieldName: "apply_now_is_cta",
      label: "Is CTA (lead popup)",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "On = open lead capture popup instead of the CTA URL",
      defaultValue: true,
    },
    {
      fieldName: "apply_now_link",
      label: "CTA URL (used when Is CTA is off)",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "/contact or https://…",
      defaultValue: "",
    },
    {
      fieldName: "apply_now_color",
      label: "CTA text colour",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "apply_now_border_color",
      label: "CTA border colour",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "status",
      label: "Banner status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      defaultValue: true,
    },
  ],
};
